document.getElementById('bulk-add-to-cart').addEventListener('submit', function(event) {
  event.preventDefault();

  const form = event.target;

  // Fetch the quantity value directly from the quantity-selector input each time
  const quantityInput = document.querySelector('.quantity-selector__input');
  const quantityValue = quantityInput ? parseInt(quantityInput.value, 10) : 1;

  // Use the selected quantity in the payload
  const items = Array.from(form.querySelectorAll('[name="id"]')).map(input => ({
    id: input.value,
    quantity: quantityValue,
    properties: {
      addon_price: input.dataset.addonPrice || ""
    }
  }));

  const payload = { items };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.json();
  })
  .then(data => {
    setTimeout(() => {
      document.getElementById('add_tocart_sticky_button').removeAttribute('aria-busy');
    }, 1500);
    const cart_side = document.querySelector('cart-drawer');
    cart_side._onCartRefresh();
    cart_side.show();
  })
  .catch(error => {
    console.error('Error adding products to cart:', error);
  });
});

// Rest of the code remains unchanged to preserve original functionalities

// Add event listener for URL changes
window.addEventListener('popstate', handleUrlChange);

// Initial call to handle the current URL
handleUrlChange();

// Function to get the variant from the URL
function getVariantFromUrl() {
  const url = new URL(window.location.href);
  return url.searchParams.get('variant');
}

// Function to handle URL change
function handleUrlChange() {
  const variant = getVariantFromUrl();
  if (variant) {
    const inputHolder = document.querySelector('#root_input');
    inputHolder.value = variant;
  } else {
    console.log('No variant ID found in the URL.');
  }
}

// Function that runs when window.igData is created
function onIgDataCreated() {
  const pricesHolder = document.querySelectorAll('[data-final-price]');
  if(pricesHolder) {
    pricesHolder.forEach(element => {
      element.style.opacity = 1;
    });
  }
  const ideProduct = document.querySelector('#root_input').value;
  const price = parseFloat(window.igData?.price?.getPriceByVariantId(ideProduct));
  if (price) {
    document.querySelector('#root_input').setAttribute('data-seek', price * 100);
    const formattedNumber = (price).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    if(pricesHolder) {
      pricesHolder.forEach(element => {
        element.innerHTML = formattedNumber;
      });
    }
  }
  
  clearInterval(interval);
}

// Set initial opacity of pricesHolder elements to 0
const pricesHolder = document.querySelectorAll('[data-final-price]');
if(pricesHolder) {
  pricesHolder.forEach(element => {
    element.style.opacity = 0;
  });
}

// Interval to check for igData availability
const interval = setInterval(() => {
  console.log('window.igData', window.igData);
  if (window.igData && window.igData.price) {
    onIgDataCreated();
  }
}, 100); // Checks every 100 milliseconds
